import DateRangePicker from "./DateRangePicker";
import {DateRange} from "./DateRangePicker";

export default DateRangePicker;
export {DateRange};